// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #f8f9fa;
  padding: 15px;
  margin-top: 1rem;
}
.branch-container .branch-card {
  background-color: white;
  border: 1px solid #c4c4c4;
  border-radius: 0.3rem;
  padding: 1.5rem;
  cursor: pointer;
}
.branch-container .branch-card .branch-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}
.branch-container .branch-card .branch-header .branch-title-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.branch-container .branch-card .branch-header .branch-title-wrapper .branch-label {
  background-color: #e5e7eb;
  color: #374151;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem;
  width: fit-content;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.branch-container .branch-card .branch-header .branch-title-wrapper .branch-name {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1f2937;
  position: relative;
}
.branch-container .branch-card .branch-header .branch-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}
.branch-container .branch-card .branch-header .branch-actions .branch-action-btn {
  color: black;
  border: none;
  border-radius: 9999px;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
.branch-container .branch-card .branch-header .branch-actions .edit-branch {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.branch-container .branch-card .branch-header .branch-actions .edit-branch:hover {
  background-color: #f8f9fa;
  opacity: 0.9;
}
.branch-container .branch-card .branch-header .branch-actions .manual-add,
.branch-container .branch-card .branch-header .branch-actions .spreadsheet-add,
.branch-container .branch-card .branch-header .branch-actions .members-action {
  border-radius: 0.375rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  width: auto;
}
.branch-container .branch-card .branch-header .branch-actions .manual-add {
  background-color: #2E8B57;
}
.branch-container .branch-card .branch-header .branch-actions .spreadsheet-add {
  background-color: var(--primary-color);
}
.branch-container .branch-card .branch-header .branch-actions .members-action {
  background-color: var(--primary-color);
  transition: opacity 0.2s ease;
}
.branch-container .branch-card .branch-header .branch-actions .members-action:hover {
  opacity: 0.9;
}
.branch-container .branch-card .branch-meta {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}
.branch-container .branch-card .branch-meta .branch-detail-value {
  color: #135bc0;
  font-weight: 600;
}
.branch-container .branch-card .branch-meta .branch-meta-separator {
  display: inline-block;
  width: 24px;
}
.branch-container .branch-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(900px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.branch-container .branch-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 6px var(--shadow-light);
  font-size: 0.95rem;
}
.branch-container .branch-table thead {
  background-color: #f1f5f9;
}
.branch-container .branch-table thead th {
  text-align: left;
  padding: 1rem;
  color: var(--text-color-dark);
  font-weight: 600;
  border-bottom: 1px solid var(--border-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.85rem;
}
.branch-container .branch-table tbody tr {
  transition: background-color 0.2s ease;
}
.branch-container .branch-table tbody tr:hover {
  background-color: #f9fafb;
}
.branch-container .branch-table tbody tr td {
  padding: 0.9rem 1rem;
  color: var(--text-color-medium);
  border-bottom: 1px solid var(--border-color);
}
.branch-container .branch-table tbody tr td.bold {
  color: var(--text-color-dark);
  font-weight: 600;
}
.branch-container .branch-table tbody tr td.highlight {
  color: var(--accent-color);
  font-weight: 700;
}
.branch-container .branch-table tbody tr td:last-child {
  white-space: nowrap;
}
.branch-container .branch-table tbody tr td:last-child button {
  margin-left: 0.3rem;
  padding: 0.35rem 0.7rem;
  font-size: 0.8rem;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.branch-container .branch-table tbody tr td:last-child button.edit-btn {
  background-color: #17a2b8;
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.edit-btn:hover {
  opacity: 0.9;
}
.branch-container .branch-table tbody tr td:last-child button.manual-btn {
  background-color: #2E8B57;
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.spreadsheet-btn {
  background-color: var(--primary-color);
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.members-btn {
  background-color: var(--primary-color);
  color: white;
}
.branch-container .branch-table tbody tr td:last-child button.members-btn:hover {
  opacity: 0.9;
}
.branch-container .branch-table tbody tr:last-child td {
  border-bottom: none;
}
.branch-container .no-data {
  text-align: center;
  padding: calc(var(--spacing-unit) * 3);
  font-size: 1rem;
  color: var(--text-color-medium);
  border: 1px dashed var(--border-color);
  background: var(--card-bg);
  border-radius: 0.5rem;
  margin-top: 1rem;
}
.branch-container .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-left: auto;
  padding: 1rem 0;
}
.branch-container .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  padding: 0.3rem 0.6rem;
  font-size: 0.9rem;
  background-color: transparent;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  color: #374151;
}
.branch-container .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #f3f4f6;
  font-weight: 600;
}
.branch-container .view-toggle-wrapper .view-toggle-btn svg {
  margin-right: 4px;
}
.branch-container .no-branch-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

@media (max-width: 640px) {
  .branch-container .branch-card .branch-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  .branch-container .branch-card .branch-header .branch-actions {
    align-self: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .branch-container .branch-card .branch-header .branch-actions .branch-action-btn {
    width: auto;
    height: auto;
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
    border-radius: 0.375rem;
  }
  .branch-container .branch-card .branch-header .branch-title-wrapper .branch-name::after {
    width: 60%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Branch/Branch.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACN;AACM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACR;AACQ;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AACV;AAEQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAV;AAIM;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AAFR;AAIQ;EAGE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AAJV;AAOQ;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AALV;AAMU;EACE,yBAAA;EACA,YAAA;AAJZ;AAQQ;;;EAGE,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AANV;AASQ;EACE,yBAAA;AAPV;AAUQ;EACE,sCAAA;AARV;AAWQ;EACE,sCAAA;EACA,6BAAA;AATV;AAWU;EACE,YAAA;AATZ;AAeI;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AAbN;AAeM;EACE,cAAA;EACA,gBAAA;AAbR;AAgBM;EACE,qBAAA;EACA,WAAA;AAdR;AA6BE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AA3BJ;AAgCE;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;AA9BJ;AAgCI;EACE,yBAAA;AA9BN;AAgCM;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,4CAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA9BR;AAmCM;EACE,sCAAA;AAjCR;AAmCQ;EACE,yBAAA;AAjCV;AAoCQ;EACE,oBAAA;EACA,+BAAA;EACA,4CAAA;AAlCV;AAoCU;EACE,6BAAA;EACA,gBAAA;AAlCZ;AAqCU;EACE,0BAAA;EACA,gBAAA;AAnCZ;AAuCQ;EACE,mBAAA;AArCV;AAwCU;EACE,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AAtCZ;AAwCY;EACE,yBAAA;EACA,YAAA;AAtCd;AAwCc;EAEE,YAAA;AAvChB;AA2CY;EACE,yBAAA;EACA,YAAA;AAzCd;AA4CY;EACE,sCAAA;EACA,YAAA;AA1Cd;AA6CY;EACE,sCAAA;EACA,YAAA;AA3Cd;AA6Cc;EACE,YAAA;AA3ChB;AAkDM;EACE,mBAAA;AAhDR;AAqDE;EACE,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,+BAAA;EACA,sCAAA;EACA,0BAAA;EACA,qBAAA;EACA,gBAAA;AAnDJ;AAuDE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AArDJ;AAuDI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AArDN;AAuDM;EACE,yBAAA;EACA,gBAAA;AArDR;AAwDM;EACE,iBAAA;AAtDR;AA2DE;EAKU,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA7DZ;;AAmEA;EAGM;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;EAlEN;EAoEM;IACE,mBAAA;IACA,2BAAA;IACA,eAAA;EAlER;EAoEQ;IACE,WAAA;IACA,YAAA;IACA,sBAAA;IACA,iBAAA;IACA,uBAAA;EAlEV;EAuEQ;IACE,UAAA;EArEV;AACF","sourcesContent":[".branch-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background-color: #f8f9fa;\n  padding: 15px;\n  margin-top: 1rem;\n\n  .branch-card {\n    background-color: white;\n    border: 1px solid #c4c4c4;\n    border-radius: 0.3rem;\n    padding: 1.5rem;\n    cursor: pointer;\n\n    .branch-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin: 0;\n\n      .branch-title-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 0.6rem;\n\n        .branch-label {\n          background-color: #e5e7eb;\n          color: #374151;\n          font-size: 0.75rem;\n          font-weight: 500;\n          padding: 0.2rem 0.5rem;\n          border-radius: 0.25rem;\n          width: fit-content;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n        }\n\n        .branch-name {\n          font-size: 1.2rem;\n          font-weight: 700;\n          color: #1f2937;\n          position: relative;\n        }\n      }\n\n      .branch-actions {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.5rem;\n        justify-content: flex-end;\n\n        .branch-action-btn {\n          // background-color: var(--warning-color);\n          // color: white;\n          color: black;\n          border: none;\n          border-radius: 9999px;\n          width: 2rem;\n          height: 2rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          transition: background-color 0.2s;\n        }\n\n        .edit-branch {\n          margin-right: 0.5rem;\n          padding: 0.3rem 0.6rem;\n          font-size: 0.85rem;\n          border: none;\n          border-radius: 6px;\n          cursor: pointer;\n          &:hover{\n            background-color: #f8f9fa;\n            opacity: 0.9;\n          }\n        }\n\n        .manual-add,\n        .spreadsheet-add,\n        .members-action {\n          border-radius: 0.375rem;\n          padding: 0.4rem 0.75rem;\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: auto;\n          width: auto;\n        }\n\n        .manual-add {\n          background-color: #2E8B57;\n        }\n\n        .spreadsheet-add {\n          background-color: var(--primary-color);\n        }\n\n        .members-action {\n          background-color: var(--primary-color);\n          transition: opacity 0.2s ease;\n\n          &:hover {\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n\n    .branch-meta {\n      margin-top: 0.5rem;\n      font-size: 0.875rem;\n      color: #6b7280;\n\n      .branch-detail-value {\n        color: #135bc0;\n        font-weight: 600;\n      }\n\n      .branch-meta-separator {\n        display: inline-block;\n        width: 24px;\n      }\n    }\n\n    // &:hover{\n    //   .branch-header{\n    //     .branch-actions{\n    //       .edit-branch{\n    //         opacity: 1;\n    //       }\n    //     }\n    //   }\n    // }\n  }\n\n  .branch-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(900px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n\n\n\n  .branch-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: var(--card-bg);\n    border: 1px solid var(--border-color);\n    border-radius: 0.5rem;\n    overflow: hidden;\n    box-shadow: 0 2px 6px var(--shadow-light);\n    font-size: 0.95rem;\n\n    thead {\n      background-color: #f1f5f9;\n\n      th {\n        text-align: left;\n        padding: 1rem;\n        color: var(--text-color-dark);\n        font-weight: 600;\n        border-bottom: 1px solid var(--border-color);\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        font-size: 0.85rem;\n      }\n    }\n\n    tbody {\n      tr {\n        transition: background-color 0.2s ease;\n\n        &:hover {\n          background-color: #f9fafb;\n        }\n\n        td {\n          padding: 0.9rem 1rem;\n          color: var(--text-color-medium);\n          border-bottom: 1px solid var(--border-color);\n\n          &.bold {\n            color: var(--text-color-dark);\n            font-weight: 600;\n          }\n\n          &.highlight {\n            color: var(--accent-color);\n            font-weight: 700;\n          }\n        }\n\n        td:last-child {\n          white-space: nowrap;\n          // text-align: right;\n\n          button {\n            margin-left: 0.3rem;\n            padding: 0.35rem 0.7rem;\n            font-size: 0.8rem;\n            border-radius: 0.375rem;\n            border: none;\n            cursor: pointer;\n            transition: background-color 0.2s ease;\n\n            &.edit-btn {\n              background-color: #17a2b8;\n              color: white;\n\n              &:hover {\n                //background-color: #4b5563;\n                opacity: 0.9;\n              }\n            }\n\n            &.manual-btn {\n              background-color: #2E8B57;\n              color: white;\n            }\n\n            &.spreadsheet-btn {\n              background-color: var(--primary-color);\n              color: white;\n            }\n\n            &.members-btn {\n              background-color: var(--primary-color);\n              color: white;\n\n              &:hover {\n                opacity: 0.9;\n              }\n            }\n          }\n        }\n      }\n\n      tr:last-child td {\n        border-bottom: none;\n      }\n    }\n  }\n\n  .no-data {\n    text-align: center;\n    padding: calc(var(--spacing-unit) * 3);\n    font-size: 1rem;\n    color: var(--text-color-medium);\n    border: 1px dashed var(--border-color);\n    background: var(--card-bg);\n    border-radius: 0.5rem;\n    margin-top: 1rem;\n  }\n\n\n  .view-toggle-wrapper {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    margin-left: auto;\n    padding: 1rem 0;\n\n    .view-toggle-btn {\n      display: flex;\n      align-items: center;\n      padding: 0.3rem 0.6rem;\n      font-size: 0.9rem;\n      background-color: transparent;\n      border: 1px solid #d1d5db;\n      border-radius: 4px;\n      cursor: pointer;\n      color: #374151;\n\n      &.active {\n        background-color: #f3f4f6;\n        font-weight: 600;\n      }\n\n      svg {\n        margin-right: 4px;\n      }\n    }\n  }\n\n  .no-branch-found {\n    // padding: 1rem;\n    // text-align: center;\n    // color: #6b7280;\n    // font-size: 0.95rem;\n            text-align: center;\n            font-size: 1.1rem;\n            color: var(--text-color-medium);\n            padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n            background: var(--card-bg);\n            border-radius: 0.75rem;\n            border: 1px dashed var(--border-color);\n            box-shadow: 0 2px 5px var(--shadow-light);\n            margin-top: calc(var(--spacing-unit) * 2);\n            grid-column: 1 / -1;\n  }\n\n\n}\n\n@media (max-width: 640px) {\n  .branch-container {\n    .branch-card {\n      .branch-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.75rem;\n\n        .branch-actions {\n          align-self: stretch;\n          justify-content: flex-start;\n          flex-wrap: wrap;\n\n          .branch-action-btn {\n            width: auto;\n            height: auto;\n            padding: 0.4rem 0.6rem;\n            font-size: 0.8rem;\n            border-radius: 0.375rem;\n          }\n        }\n\n        .branch-title-wrapper {\n          .branch-name::after {\n            width: 60%;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
